export default function range(value: number) {
  return Array.from(Array(value).keys());
}
